<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Garantias Locatícias';    
</script>

<PageHeader title={titlePage} buttons=""></PageHeader>    
<div class="container">
	<p>Confira os tipos de garantias locatícias disponíveis e a o que é necessário em cada uma delas.</p>
	<hr>
	<div class="box-itens-icon">
		<div class="item">
			<div class="icone">
				<i class="fas fa-shield-check fa-8x fa-fw color-accent"></i>
			</div>
			<div class="info">
				<h3>Seguro Fiança</h3>
				<p>É contratado através das Seguradoras Porto Seguro, Pottencial Seguros e Tokkio Marine Seguros, as quais garantem a locação cobrando um valor calculado sobre o aluguel, encargos, multas e reparos. Esse seguro tem validade de 30 meses, sendo esse o prazo de contrato.</p>
				<p><b>Salientamos que o valor do seguro não é restituído após a rescisão contratual.</b></p>
				<div class="mb-10">
					<a class="btn btn-rounded btn-primary" style="border: 2px solid #ffffff !important;" target="_blank" href="/assets/fichas/portoCadastroPessoaFisica.pdf">
						<b>Ficha Cadastral - Pessoa Física</b>
					</a>
				</div>
				<div class="mb-10">
					<a class="btn btn-rounded btn-primary" style="border: 2px solid #ffffff !important;" target="_blank" href="/assets/fichas/portoCadastroPessoaJuridica.pdf">
						<b>Ficha Cadastral - Pessoa Jurídica</b>
					</a>
				</div>
			</div>
		</div>
	</div>
	<hr>
	<p>Em caso de dúvidas, entre em <a href="/contato">contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>
	<hr>
	<div class="button text-center">        
		<a href="/documentacao-necessaria" use:link replace title="" class="btn btn-secondary">
			CONFIRA A DOCUMENTAÇÃO PARA LOCAÇÃO <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> 
		</a>
	</div>
	<br />

</div>